import React from 'react';
import Placeholder from '../Placeholder';
// spec says nothing about sizes of these, so arbitrary numbers
var splits = [
    [56, 160],
    [32, 64],
    [48, 32],
    [24, 80],
    [32, 120],
];
var TitlePlaceholder = function (_a) {
    var className = _a.className, _b = _a.splitIndex, splitIndex = _b === void 0 ? 0 : _b;
    var _c = splitIndex < splits.length ? splits[splitIndex] : splits[0], width1 = _c[0], width2 = _c[1];
    return (React.createElement("div", { className: className },
        React.createElement(Placeholder, { width: width1, height: 8 }),
        ' ',
        React.createElement(Placeholder, { width: width2, height: 8 })));
};
TitlePlaceholder.displayName = 'TitlePlaceholder';
export default TitlePlaceholder;
//# sourceMappingURL=TitlePlaceholder.js.map